import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useTheme } from "@mui/styles";
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import ReportView from "../../../../pages/Dashboard/components/Reports/components/ReportView";
import CircularProgress from "@mui/material/CircularProgress";

const ReportsModal = ({ reports, report }) => {
  const theme = useTheme()

  const [reportsLoaded, setReportsLoaded] = useState(false)
  const [reportLoaded, setReportLoaded] = useState(false)
  const [selectedReport, setSelectedReport] = useState(null)
  const [page, setPage] = useState(1)

  const handleChangePage = (event) => {
    let pageNumber = parseInt(event.target.innerText)
    let thisReport = reports[(pageNumber - 1)]
    setPage(pageNumber)
    setSelectedReport(thisReport)
  }

  useEffect(() => {
    if (reports !== undefined) {
      setSelectedReport(reports[0])
      setReportsLoaded(true)
    } else if (report !== undefined) {
      setSelectedReport(report)
      setReportLoaded(true)
    }
  }, [reports, report])

  return (
    <ReportsPanel>
      {reportLoaded ?
        <SingleReportBody>
          <ReportView report={selectedReport} />
        </SingleReportBody>
      : reportsLoaded ?
        <>
          <ReportsHeader>
            <HeaderText>
              Reports
            </HeaderText>
            <HeaderMeta>
              {reports.length} evidence artifact{reports.length === 1 ? '' : 's'}
            </HeaderMeta>
            <PaginationRail>
              <Stack spacing={2}>
              <Pagination onClick={(event) => handleChangePage(event)} count={reports.length} page={page} variant="outlined" color='secondary' hidePrevButton hideNextButton siblingCount={2} boundaryCount={1} />
              </Stack>
            </PaginationRail>
          </ReportsHeader>
          <ReportsBody>
            <ReportView report={selectedReport} origin={"modal"} />
          </ReportsBody>
        </>
      :
        <LoadingState>
          <CircularProgress
            sx={{ color: `${theme.palette.primary.main}`}}
            size={48}
          />
        </LoadingState>
      }
    </ReportsPanel>
  )
}

const ReportsPanel = styled.section(({ theme }) => `
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  background: ${theme.palette.common.cardBackground};
  overflow: hidden;
`)

const ReportsHeader = styled.header(({ theme }) => `
  min-height: 4rem;
  display: grid;
  grid-template-columns: minmax(10rem, 1fr) auto minmax(10rem, 1fr);
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const HeaderText = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
`)

const HeaderMeta = styled.div(({ theme }) => `
  justify-self: center;
  color: ${theme.palette.common.grayText};
  font-size: 0.85rem;
  font-weight: 700;
`)

const PaginationRail = styled.div`
  justify-self: end;
  min-width: 0;
`

const ReportsBody = styled.div(({ theme }) => `
  min-height: 0;
  display: flex;
  justify-content: center;
  padding: 1rem;
  overflow: hidden;
  background: ${theme.palette.common.grayBorderLight};
`)

const SingleReportBody = styled(ReportsBody)`
  grid-row: 1 / 3;
`

const LoadingState = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default ReportsModal;
